/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionActivePolicySearchCompanyQuery = gql`
  query GetSouscriptionActivePolicySearchCompanyQuery($clientId: String, $riskName: String) {
    getSouscriptionActivePolicySearchCompany_souscription_active_policy(clientId: $clientId, riskName: $riskName) {
      jrmcCompanies {
 value  
label  
id  
}
    }
  }
`;

export default GetSouscriptionActivePolicySearchCompanyQuery;
